<template>
  <b-container>
    <vue-bootstrap-typeahead
      class="mb-4"
      v-model="personSearch"
      :data="users"
      :serializer="s => s.val +' (' +s.key + ')'"
      @hit="selected($event)"
      placeholder="Search for member"
    />

    <b-modal ref="addMember" id="addMember" hide-footer title="Add Member">
      <b-form @submit="addMember()">
        <p class="text-warning">This user is not a current member of the application.</p>
        <b-button variant="outline-primary" type="submit">
          <b-icon-archive-fill></b-icon-archive-fill>Add Member
        </b-button>
      </b-form>
    </b-modal>

    <b-modal ref="activateMember" id="activateMember" hide-footer title="Activate Member">
      <b-form @submit="activateMember()">
        <p class="text-warning">This users account is inactivated!</p>
        <b-button variant="outline-primary" type="submit">
          <b-icon-archive-fill></b-icon-archive-fill>Activate Member
        </b-button>
      </b-form>
    </b-modal>

    <div v-if="selectedUser">
      <h1 class="mb-12">
        {{selectedUser.name}}
        <sup v-show="active === false" class="text-warning">Inactivated</sup>
        <sup v-show="active === null" class="text-warning">Not a Member</sup>
      </h1>

      <b-button v-b-modal.addRoleModal variant="outline-primary" v-show="active==true">
        <b-icon-plus></b-icon-plus>Add role
      </b-button>

      <b-modal ref="addRoleModal" id="addRoleModal" hide-footer title="Add Role">
        <b-form @submit="addRole()">
          <b-row class="my-1">
            <b-col sm="3">
              <label for="roleField">Role:</label>
            </b-col>
            <b-col sm="9">
              <b-form-select
                id="roleField"
                v-model="roleId"
                value-field="roleId"
                text-field="role"
                :options="roles"
              ></b-form-select>
            </b-col>
          </b-row>
          <b-button variant="outline-primary" type="submit">
            <b-icon-archive-fill></b-icon-archive-fill>Save
          </b-button>
        </b-form>
      </b-modal>


      <b-row class="my-1" v-for="role in selectedUser.roles" :key="role.roleId">
        <b-col sm="6" class="text-right">
          <b-button
            variant="outline-primary"
            v-on:click="revoke(role.roleId, selectedUser.userId)"
          >
            <b-icon-trash-fill></b-icon-trash-fill>Remove Role
          </b-button>
        </b-col>
        <b-col sm="6">
          <P class="sm-4">{{role.role}}</P>
        </b-col>
      </b-row>
    </div>
  </b-container>
</template>
<script>
import { mixins } from "../mixins";
import VueBootstrapTypeahead from "vue-bootstrap-typeahead";
import _ from "underscore";

export default {
  name: "members",
  mixins: [mixins],
  components: {
    VueBootstrapTypeahead
  },
  data() {
    return {
      users: [],
      roles: [],
      active: null,
      personSearch: "",
      selectedUser: null,
      roleId: null
    };
  },
  created() {
    this.api
        .get('/secure/securityRoles',)
        .then((results) => {
          this.roles = results.data;
        })
        .catch(error => {
          this.errorToast(error.response.data.message || error.message || "");
        });
  },
  methods: {
    addRole() {
      this.api
        .post('/secure/addRole',{
          userId: this.selectedUser.userId,
          roleId: this.roleId
        })
        .then(() => {
          this.$refs["addRoleModal"].hide();
          this.selected({ key: this.selectedUser.userId});
        })
        .catch(error => {
          this.errorToast(error.response.data.message || error.message || "");
        });     
    },
    addMember() {
      this.api
        .post('/secure/addMember',{
          userId: this.selectedUser.userId
        })
        .then(() => {
          this.$refs["addMember"].hide();
          this.activateMember = true;
          this.successToast('User was added')
        })
        .catch(error => {
          this.errorToast(error.response.data.message || error.message || "");
        });       
    },
    activateMember() {
      this.api
        .post('/secure/activateMember',{
          userId: this.selectedUser.userId
        })
        .then(() => {
          this.$refs["activateMember"].hide();
          this.successToast('User was activated');
          this.active = true;
        })
        .catch(error => {
          this.errorToast(error.response.data.message || error.message || "");
        });       
    },    
    search(newQuery) {
      this.api
        .post("/secure/userSearch", {
          query: newQuery
        })
        .then(response => {
          this.users = response.data;
        })
        .catch(error => {
          this.errorToast(error.response.data.message || error.message || "");
        });
    },
    selected(record) {
      this.api
        .post("/secure/userInfo", {
          userId: record.key
        })
        .then(response =>  {
          this.selectedUser = response.data;
          if (("member" in this.selectedUser)) {
            if (this.selectedUser.member == false) {
              this.active = false;
              this.$bvModal.show("addMember");
            } else  if (("active" in this.selectedUser)) {
              if (this.selectedUser.active == false) {
                this.active = false;
                this.$bvModal.show("activateMember")
              } else {
                this.active = true;
              }
            }
          }
        })
        .catch(error => {
          this.errorToast(error.response.data.message || error.message || "");
        });
    },
    revoke(roleId, userId) {
      this.api
        .post("/secure/revokeRole", {
          roleId: roleId,
          userId: userId
        })
        .then(() => {
          this.selected({ key: userId });
        })
        .catch(error => {
          this.errorToast(error.response.data.message || error.message || "");
        });
    }
  },
  watch: {
    personSearch: _.debounce(function(searchString) {
      this.search(searchString);
    }, 500)
  }
};
</script>
